import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { videoTo911Api } from './videoTo911Api';

const initialState = {
  rooms: {},
};

export const videoTo911Slice = createSlice({
  name: 'videoTo911',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        videoTo911Api.endpoints.createRoom.matchFulfilled,
        (state, action) => {
          const callerId = action.meta.arg.originalArgs?.callerId;
          const callStartTime = action.meta.arg.originalArgs?.callStartTime;
          return {
            ...state,
            rooms: {
              ...state.rooms,
              [action.payload.room_id]: {
                ...action.payload,
                callerId,
                callStartTime, // used for ending the room
              },
            },
          };
        },
      )
      .addMatcher(
        videoTo911Api.endpoints.refreshClientToken.matchPending,
        (state, action) => {
          const roomId = action.meta.arg.originalArgs?.roomId;
          return {
            ...state,
            rooms: {
              ...state.rooms,
              [roomId]: {
                ...state.rooms?.[roomId],
              },
            },
          };
        },
      )
      .addMatcher(
        videoTo911Api.endpoints.refreshClientToken.matchFulfilled,
        (state, action) => {
          const roomId = action.meta.arg.originalArgs?.roomId;
          return {
            ...state,
            rooms: {
              ...state.rooms,
              [roomId]: {
                ...state.rooms?.[roomId],
                ...action.payload,
              },
            },
          };
        },
      )
      .addMatcher(
        videoTo911Api.endpoints.refreshClientToken.matchRejected,
        (state, action) => {
          // failed to refresh token. the video session is either over or the refresh token expired
          const roomId = action.meta.arg.originalArgs?.roomId;
          return {
            ...state,
            rooms: {
              ...state.rooms,
              [roomId]: {
                ...state.rooms?.[roomId],
              },
            },
          };
        },
      )
      .addMatcher(
        isAnyOf(
          videoTo911Api.endpoints.endRoom.matchFulfilled,
          videoTo911Api.endpoints.endRoom.matchRejected,
        ),
        (state, action) => {
          // Regardless of API success/failure, the UI will appear as succesful
          const roomId = action.meta.arg.originalArgs?.roomId;
          const filteredRooms = Object.keys(state.rooms)
            .filter(room => {
              room.room_id !== roomId;
            })
            .reduce((obj, key) => {
              obj[key] = state.rooms[key];
              return obj;
            }, {});

          return {
            ...state,
            rooms: filteredRooms,
          };
        },
      )
      .addMatcher(
        action => 'emergencyCalls/removeCall'.includes(action.type),
        (state, action) => {
          // Remove any rooms for the given caller ID
          Object.keys(state.rooms).forEach(roomID => {
            if (state.rooms[roomID].callerId === action.payload) {
              delete state.rooms[roomID];
            }
          });
        },
      )
      .addMatcher(
        action => 'emergencyCalls/removeAllCalls'.includes(action.type),
        () => {
          return initialState;
        },
      )
      .addMatcher(
        action => ('LOGOUT_SUCCESS', 'SINATRA_LOGOUT').includes(action.type),
        () => {
          return initialState;
        },
      );
    // .addCase(removeFromQueue)
  },
});

const persistConfig = {
  key: 'videoTo911',
  storage,
};

const persistedReducer = persistReducer(persistConfig, videoTo911Slice.reducer);

export default persistedReducer;
